import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { SearchTable } from '../../components/utils/SearchTable';
import { DatePickerABX } from '../../components/pickers/DatePicker';
import { useKilometraje } from '../../../hooks/registros/useKilometraje';
import { classNameInput, formatDate, notify, stringToNewDate } from '../../../utils/utils';
import { useBloqueoPantalla } from '../../../hooks/useBloqueoPantalla';
import { Select2 } from '../../components/forms/Select2';



export const Kilometrajes = () => {
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()
    const inputLecturaActual = useRef()
    const kilometrajeDefault = {
        codUnidad: 0,
        padronUnidad: "",
        placaUnidad: "",
        ultimaLectura: 0,
        nuevaLectura: 0,
        observacion: "",
        codUnidadKilometraje: 0
    }
    
    const {
        listarUnidades,
        unidades,
        listarKilometrajes,
        kilometrajes,
        listarUltimasLecturas,
        ultimasLecturas,
        registrarKilometraje,
        editarKilometraje,
        eliminarKilometraje,

        listarHistorialKilometraje,
        historialKilometraje
    } = useKilometraje()
    
    const [isOpenModalActualizar,openModalActualizar,closeModalActualizar] = useModal()
    const [isOpenModalHistorial,openModalHistorial,closeModalHistorial] = useModal()

    const [kilometrajeModal,setKilometrajeModal] = useState(kilometrajeDefault)

    useEffect(() => {
        (async () => {
            bloquearPantalla()
            await listarKilometrajes()
            await listarUnidades()
            desbloquearPantalla()
        })()
    }, [])


    const funcionListarTabla = async () => {
        await listarKilometrajes()
    }
    

    const funcionActualizarKilometraje = async () => {
        const response = (kilometrajeModal.codUnidadKilometraje == 0) ?
            await registrarKilometraje({
                codUnidad: kilometrajeModal.codUnidad,
                ultimaLectura: kilometrajeModal.nuevaLectura,
                observacion: kilometrajeModal.observacion
            })
        : 
            await editarKilometraje({
                codUnidadKilometraje: kilometrajeModal.codUnidadKilometraje,
                ultimaLectura: kilometrajeModal.nuevaLectura,
                observacion: kilometrajeModal.observacion
            })
            
        notify(response.DesResultado,response.CodResultado == 1 ? 'success' : 'error')
        if(response.CodResultado == 1){
            await funcionListarTabla()
            closeModalActualizar()
        }

    }

    const editarValorKilometraje = (key,valor) => {
        setKilometrajeModal(jsonAnterior => {
            return {
                ...jsonAnterior,
                [key]:valor
            }
        })
    }


    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <div className='w-full h-full flex flex-col'>
                <ContenedorParametros
                    titulo='Kilometrajes' tablaId={'tablaId'}
                >   
                    <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>       
                    
                </ContenedorParametros>
                
                <Tooltip id={'Departamento'}>Departamento</Tooltip>
                <Tooltip id={'Provincia'}>Provincia</Tooltip>
                <Tooltip id={'Distrito'}>Distrito</Tooltip>
                <Tooltip id={'Estado'}>Estado</Tooltip>
                <Tooltip id={'Categoria'}>Categoria</Tooltip>

                <div className="containerScroll mt-7 relative flex-1 overflow-auto">
                    <table id="tablaId" className="tableResponsive">
                        <thead>
                            <tr>
                                <th className="w-[20px]">N°</th>
                                <th className="">PAD</th>
                                <th className="">PLACA</th>
                                <th className="">FECHA ACTUALIZACIÓN</th>
                                <th className="">KILOMETRAJE</th>
                                <th className="">ULTIMO COMENTARIO</th>
                                <th className="w-[50px]"></th>
                                <th className="w-[50px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            kilometrajes.length > 0 
                                ? kilometrajes.map((data, i) => {
                                    return (
                                        <tr key={i+1} className=''>
                                            <td data-label="" className='tablenum  w-[20px]'> {i+1}</td>
                                            <td data-label="PAD" className="">{data.padronUnidad}</td>
                                            <td data-label="PLACA" className="">{data.placaUnidad}</td>
                                            <td data-label="F. Actualización" className="">{data.fechaActualizacion || '-'}</td>
                                            <td data-label="Ultima lectura" className="">{data.ultimaLectura}</td>
                                            <td data-label="Ultimo comentario" className="">{data.observacion || '-'}</td>
                                            <td data-label="Actualizar información" className="text-center" >
                                                <button 
                                                    onClick={() => {
                                                        editarValorKilometraje('codUnidad',data.codUnidad)
                                                        editarValorKilometraje('padronUnidad',data.padronUnidad)
                                                        editarValorKilometraje('placaUnidad',data.placaUnidad)
                                                        editarValorKilometraje('ultimaLectura',data.ultimaLectura)
                                                        editarValorKilometraje('nuevaLectura',Number(data.ultimaLectura) + 1)       // PARA EDITAR
                                                        editarValorKilometraje('observacion','')
                                                        editarValorKilometraje('codUnidadKilometraje',data.codUnidadKilometraje)

                                                        openModalActualizar()
                                                    }} 
                                                    className='w-[25px] h-[25px] bg-blue-600 rounded text-xs'
                                                >
                                                    <i className='fas fa-edit'></i>
                                                </button>
                                            </td>
                                            <td data-label="Histórico" className="text-center" >
                                                <button 
                                                    onClick={() => {
                                                        listarHistorialKilometraje(data.codUnidad)
                                                        openModalHistorial()
                                                    }}
                                                    className='w-[25px] h-[25px] bg-orange-600 rounded text-xs'
                                                >
                                                    <i className='fas fa-clock'></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            : <tr><td colSpan="9" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                        }
                        </tbody> 
                    </table>
                </div>
            </div>

            <Modal
                isOpen={isOpenModalActualizar}
                title={'Kilometraje - Lectura'}     // CAMBIAR NOMBRE
                closeModal={closeModalActualizar}
                action={funcionActualizarKilometraje}
            >
                <section className='flex flex-col gap-4 w-[400px] p-2'>
                    <div className='grid grid-cols-3 gap-2'>
                        <span>Unidad</span>
                        <input disabled defaultValue={`${kilometrajeModal.padronUnidad} ${kilometrajeModal.placaUnidad}`} className={`${classNameInput} col-span-2 cursor-not-allowed`}></input>
                        <span>Último kilometraje registrado</span>
                        <input disabled defaultValue={kilometrajeModal.ultimaLectura} type='number' min={0} className={`${classNameInput} col-span-2 cursor-not-allowed`}></input>
                        <span>Nuevo kilometraje</span>
                        <input value={kilometrajeModal.nuevaLectura} onChange={e => editarValorKilometraje('nuevaLectura',e.target.value)} type='number' min={0} className={`${classNameInput} col-span-2`}></input>
                    </div>
                    <textarea value={kilometrajeModal.observacion} onChange={e => editarValorKilometraje('observacion',e.target.value)} placeholder='(Comentario)' className={`${classNameInput} h-[100px]`}></textarea>
                </section>
            </Modal>

            <Modal
                title={'Historial unidad'}
                isOpen={isOpenModalHistorial}
                closeModal={closeModalHistorial}
                validButton={{}}
            >
                <div>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th>Nº</th>
                                <th>UNIDAD</th>
                                <th>LECTURA ANTERIOR</th>
                                <th>ÚLTIMA LECTURA</th>
                                <th>USUARIO</th>
                                <th>FECHA CREACIÓN</th>
                                <th>COMENTARIO</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                historialKilometraje.length != 0 ?
                                    historialKilometraje.map((data,i) => {
                                        return(
                                            <tr key={i+1}>
                                                <td>{i+1}</td>
                                                <td>{data.unidad}</td>
                                                <td>{data.lecturaAnterior}</td>
                                                <td>{data.ultimaLectura}</td>
                                                <td>{data.nomUsuario}</td>
                                                <td>{data.fechaCreacion}</td>
                                                <td>{data.observacion}</td>
                                            </tr>
                                        )
                                    })
                                :   <tr><td colSpan={7} className='text-center'>No hay información con los parametros seleccionados...</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Modal>
        </>
    )
}